"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewError = void 0;
var NewError = /** @class */ (function () {
    function NewError(errorCode, error) {
        this.error = error;
        this.errorCode = errorCode;
    }
    NewError.prototype.getStatusText = function () {
        return this.error.statusText;
    };
    NewError.prototype.getStatusCode = function () {
        return this.errorCode;
    };
    NewError.prototype.getError = function () {
        return this.error;
    };
    NewError.prototype.getMessage = function () {
        return this.error.data.status.message || 'There was an error';
    };
    return NewError;
}());
exports.NewError = NewError;
